var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { UiIncremental } from '@claims-ia/design-system';
import { ExternalDamageComponent } from '../ExternalDamageComponent';
import LengthInput from '@declaration/components/LengthInput.vue';
import { FRONT_WALL_FLOOR_COUNT_LABEL, FRONT_WALL_WIDENESS_LABEL, } from '@declaration/constants/externalDamages/FrontWallConstants';
let FrontWall = class FrontWall extends ExternalDamageComponent {
    mounted() {
        if (this.externalDamage.frontWallFloorCount == null) {
            this.frontWallFloorCount = 1;
        }
    }
    get frontWallFloorCountLabel() {
        return this.translateExternalDamageKey(FRONT_WALL_FLOOR_COUNT_LABEL);
    }
    get frontWallFloorWidenessLabel() {
        return this.translateExternalDamageKey(FRONT_WALL_WIDENESS_LABEL);
    }
    get frontWallFloorCount() {
        var _a;
        return (_a = this.externalDamage.frontWallFloorCount) !== null && _a !== void 0 ? _a : 1;
    }
    set frontWallFloorCount(frontWallFloorCount) {
        this.updateExternalDamage({ frontWallFloorCount });
    }
    get frontWallWideness() {
        var _a;
        return (_a = this.externalDamage.frontWallWideness) !== null && _a !== void 0 ? _a : 0;
    }
    set frontWallWideness(frontWallWideness) {
        this.updateExternalDamage({ frontWallWideness });
    }
};
FrontWall = __decorate([
    Component({ components: { UiIncremental, LengthInput } })
], FrontWall);
export default FrontWall;
